import {
  ServiceAnniversariesListApiProps,
  ServiceAnniversariesListResponse,
} from '../../../types/Dashboard/ServiceAnniversaries/serviceAnniversariesListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { AllowedHttpMethods, dashboardApiConfig } from '../apiList'

const getAllServiceAnniversariesList = async (
  props: ServiceAnniversariesListApiProps,
): Promise<ServiceAnniversariesListResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.getAllServiceAnniversaries,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 3,
      startIndex: props.startIndex ?? 0,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const ServiceAnniversariesApi = {
  getAllServiceAnniversariesList,
}

export default ServiceAnniversariesApi
